import { Chart, registerables, Tooltip } from 'chart.js';
Chart.register(...registerables);
Chart.register(Tooltip);

class ChartSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.labels = this.root.querySelectorAll('[data-legend-item]');
        this.chart = this.root.querySelector('[data-chart]');
        this.chartMidText = this.root.querySelector('[data-chart-mid-text]');
        this.canvas = this.root.querySelector('[data-chart-canvas]');

        this.settings = JSON.parse(this.chart.getAttribute('data-chart-data'));
        this.chartHandler = null;

        this.timer = null;
        this.currentHoverIndex = null;

        return true;
    }

    init() {
        this.setPlugins();

        setTimeout(() => {
            this.initChart();
            this.initTimer();
            this.initLabels();
        }, 300);
    }

    initTimer() {
        clearInterval(this.timer);
        this.timer = null;

        this.root.classList.add('hover');
        this.clearLabels();
        if (this.currentHoverIndex == null) this.currentHoverIndex = 0;

        let value =
            this.chartHandler.data.datasets[0].data[this.currentHoverIndex];
        value = value.replace('.', ',');
        
        this.labels[this.currentHoverIndex].classList.add('active');
        this.chartMidText.innerHTML = `${value}%`;

        this.setActiveArcs(this.currentHoverIndex);

        this.timer = setInterval(() => {
            this.setActiveArcs(this.currentHoverIndex);
            this.clearLabels();

            let value =
                this.chartHandler.data.datasets[0].data[this.currentHoverIndex];
            value = value.replace('.', ',');

            const labelEl = this.labels[this.currentHoverIndex];
            labelEl.classList.add('active');
            this.root.classList.add('hover');
            this.chartMidText.innerHTML = `${value}%`;

            this.currentHoverIndex = this.currentHoverIndex + 1;
            if (this.currentHoverIndex > this.labels.length - 1)
                this.currentHoverIndex = 0;
        }, 4000);
    }

    initChart() {
        this.chartHandler = new Chart(this.canvas, this.settings);
    }

    initLabels() {
        if (!this.labels) return;

        this.onLabel = this.onLabelClick.bind(this);
        this.labels.forEach(item =>
            item.addEventListener('click', this.onLabel)
        );
    }

    setPlugins() {
        const ShadowPlugin = {
            beforeDraw: (chart, args, options) => {
              const { ctx } = chart;
              ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
              ctx.shadowBlur = 5;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 0;
            },
        };

        this.settings.options.plugins = {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        };

        this.settings.options.events = [];

        this.settings.options.onClick = (e, activeElements, chart) => {
            if (this.timer !== null) {
                clearInterval(this.timer);
                this.timer = null;
            }

            if (activeElements[0]) {
                const clickedArc = activeElements[0];
                const { index } = clickedArc;

                this.currentHoverIndex = index;
                this.clearLabels();

                let value =
                    this.chartHandler.data.datasets[0].data[
                        this.currentHoverIndex
                    ];

                const labelEl = this.labels[this.currentHoverIndex];
                labelEl.classList.add('active');
                this.root.classList.add('hover');
                this.chartMidText.innerHTML = `${value}%`;

                this.setActiveArcs(this.currentHoverIndex);
            } else {
                this.chartHandler._metasets[0].data[
                    this.currentHoverIndex
                ].active = true;
                this.chartHandler.update();
            }
        };
    }

    setActiveArcs(index) {
        this.chartHandler._metasets[0].data.forEach(item => {
            item.active = false;
            item.$context.active = false;
        });

        this.chartHandler._metasets[0].data[index].active = true;
        this.chartHandler._metasets[0].data[index].$context.active = true;
        this.chartHandler.update();
    }

    clearLabels() {
        if (!this.labels) return;
        this.labels.forEach(item => item.classList.remove('active'));
    }

    onLabelClick(event) {
        if (this.timer !== null) {
            clearInterval(this.timer);
            this.timer = null;
        }

        const { currentTarget } = event;
        const index = parseInt(currentTarget.getAttribute('data-legend-item'));

        this.clearLabels();
        this.currentHoverIndex = index;

        let value =
            this.chartHandler.data.datasets[0].data[this.currentHoverIndex];
        this.labels[this.currentHoverIndex].classList.add('active');
        this.chartMidText.innerHTML = `${value}%`;

        this.setActiveArcs(this.currentHoverIndex);
    }
}

const sections = document.querySelectorAll('[data-chart-section]');
const initChartSections = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new ChartSection(el);
    });
};

initChartSections(sections);
